import React from 'react';
import styled from 'styled-components';
import { IGutterProps } from '../../fundamentals/spaces/space';
import { FONT_WEIGHTS } from '../../fundamentals/typography/typography';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { ITextProps, Span } from '../Texts/Texts';

export type EllipsisFontWeight = typeof FONT_WEIGHTS.REGULAR | typeof FONT_WEIGHTS.MEDIUM;

export interface IEllipsisProps extends Pick<ITextProps, 'textSize'>, IGutterProps {
  fontWeight?: EllipsisFontWeight;
}

const CentredSpan = styled(Span)`
  align-self: center;
`;

export const Ellipsis: React.FC<IEllipsisProps> = ({ fontWeight, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Ellipsis');

  return (
    <CentredSpan gutterLeft={8} gutterRight={8} {...generateTestId()} fontWeightCss={fontWeight} {...rest}>
      &hellip;
    </CentredSpan>
  );
};
